import script from "./CoverArtGeneratorView.vue?vue&type=script&setup=true&lang=js"
export * from "./CoverArtGeneratorView.vue?vue&type=script&setup=true&lang=js"

import "./CoverArtGeneratorView.vue?vue&type=style&index=0&id=629d480f&lang=scss"

const __exports__ = script;

export default __exports__